import React, { useEffect } from 'react';
import { AccountBalanceWallet, Close } from '@material-ui/icons';
import GridContainer from 'components/Grid/GridContainer';
import Button from 'components/CustomButtons/Button';
import GridItem from 'components/Grid/GridItem';
import { TextField } from '@material-ui/core';

function TabCash(props) {
  const { totalAmount, payWithDocuments } = props;
  const { payment, setPayment } = props;
  const { paymentMethod, setPaymentMethod } = props;

  function handleSubmit(e) {
    e.preventDefault();
    if (paymentMethod === 'CH') {
      setPaymentMethod(null);
      return;
    }
    setPaymentMethod('CH');
    setPayment((payment) => ({ ...payment, CashSum: totalAmount }));
  }

  useEffect(() => {
    if (payment.CashSum === undefined) return;
    setPayment((payment) => ({ ...payment, CashSum: totalAmount }));
  }, [totalAmount]);

  return (
    <GridContainer style={{ width: '100%' }}>
      <GridItem xs={6} lg={4}>
        <form id="formCH" onSubmit={handleSubmit}>
          <TextField
            name="CashSum"
            fullWidth
            label="Monto a pagar"
            type="number"
            value={totalAmount || 0}
            onInput={(e) => {
              let CashSum = e.target.value;
              // Si es adelanto de sueldo, no verificar
              if (!payWithDocuments) {
                setPayment((payment) => ({ ...payment, CashSum }));
                return;
              }

              // Si el DocType no es Cliente, validar
              if (payment.DocType !== 'C') {
                if (CashSum > totalAmount) {
                  setPayment((payment) => ({ ...payment, CashSum: totalAmount }));
                  return;
                }
              }

              setPayment((payment) => ({ ...payment, CashSum }));
            }}
            inputProps={{
              min: 0,
              step: 0.0001,
            }}
            required
            disabled={paymentMethod !== null}
          />
        </form>
      </GridItem>
      <GridItem xs={6}>
        <Button
          color={paymentMethod === 'CH' ? 'danger' : 'primary'}
          size="sm"
          form="formCH"
          type="submit"
        >
          {paymentMethod === 'CH' ? <Close /> : <AccountBalanceWallet />}
          {paymentMethod === 'CH' ? 'Quitar' : 'Agregar'}
        </Button>
      </GridItem>
    </GridContainer>
  );
}

export default TabCash;
